module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACfSURBVHgBpZHRDQIhDIZpdQDeCG+u4gSO4Ai6gboBG90IjnC+QTGGAcxRS4zGxOO45PoE7f99SVOlFhZ8HiEEx8zOWnubA8b4OOT8BCyflJIGgB3iqvPeb1ow0f3EPDhh9LdZQCLqiWI/JSmwZFiy579hSzIJtyQ1GGoSROzKOOdhi7jeK8UC8sUY0xb8SgBQy3X0GNys9zrxKic+1jIvdjx+jfa9yisAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 1